import React, { useMemo } from 'react';
import { AutoFields, EditView } from '@builtbypixel/nucleus';

import setup from './setup';

const EditForm = () => {
    const fields = useMemo(
        () => [
            {
                group: 'Discount Code',
                fields: [
                    {
                        name: 'name',
                        component: 'text',
                        placeholder: 'Discount Name',
                        label: 'Discount Name',
                        isRequired: true,
                        rules: { required: true },
                    },
                    {
                        name: 'code',
                        component: 'text',
                        placeholder: 'Code',
                        label: 'Code',
                        isRequired: true,
                        rules: { required: true },
                    },
                    {
                        name: 'discount',
                        component: 'text',
                        type: 'number',
                        placeholder: 'Amount',
                        label: 'Amount',
                        isRequired: true,
                        rules: { required: true },
                    },
                    {
                        name: 'discount_is_percentage',
                        component: 'switch',
                        label: 'Discount Is Percentage',
                        isRequired: true,
                        rules: { required: true },
                    },
                ],
            },
        ],
        []
    );
    return (
        <EditView setup={setup}>
            <AutoFields fields={fields} />
        </EditView>
    );
};

export default EditForm;
